import { StyleSheet } from 'aphrodite';
import { CssSelectors } from '../../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	formControlContainer: {
		display: 'flex',
		gap: 16,
		width: '100%',
		justifyContent: 'center',
	},
	formControl: {
		margin: '0 0 16px',
		flex: '1',
		maxWidth: '600px',
	},
	formField: {
		marginBottom: 16,
		width: '100%',
	},
	formActions: {
		marginTop: 24,
		display: 'flex',
		justifyContent: 'flex-end',
	},
	info: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
		flex: '1',
	},
	footer: {
		display: 'flex',
		justifyContent: 'space-between',
		marginTop: 32,
	},
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		paddingBottom: 30,
	},
	title: {
		fontSize: '18px',
	},
	modalOverrides: {
		...CssSelectors.allDescendants(
			{
				border: 'none',
				maxWidth: 1200,
				width: 1200,
			},
			'.modal-overlay-content'
		),
	},
	container: {
		width: '100%',
		maxHeight: '80vh',
		overflow: 'auto',
		paddingLeft: 36,
		paddingRight: 36,
	},
	tableStyles: {
		width: '100%',
		maxHeight: 400,
		overflow: 'auto',
	},
	suggestionsContainer: {
		display: 'flex',
		flexDirection: 'column',
	},
	autocompleteContainer: {
		position: 'relative',
		width: '100%',
	},
	autocompleteDropdown: {
		position: 'absolute',
		top: '100%',
		left: 0,
		width: '100%',
		maxHeight: '200px',
		overflow: 'auto',
		backgroundColor: 'white',
		border: '1px solid #ccc',
		borderRadius: '4px',
		boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
		zIndex: 100,
	},
	autocompleteItem: {
		padding: '8px 12px',
		cursor: 'pointer',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		fontSize: '14px',
		borderBottom: '1px solid #f0f0f0',
		':hover': {
			backgroundColor: '#f5f5f5',
		},
		':last-child': {
			borderBottom: 'none',
		},
	},
});
